<template>
  <section>
    <label class="control-label">Replicar os colaboradores por escalas anteriores</label>
    <div class="control-wrapper">
      <Select
            v-model="reference"
            :options="replicableReferences"
            :showOptionEmpty="false"
            :disabled="desactive"
          />
      <button class="btn btn-default" :disabled="desactive" @click="loadEmployees">
        Replicar
      </button>
    </div>
  </section>
</template>

<script>
import Select from '@/components/common/Select'
import request from '@/request'
import { capitalize } from '@/utils/strings'

export default {
  components: {
    Select,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    uor: {
      type: String,
      required: true
    },
    value: Array
  },
  data() {
    return {
      employeesSelected: [],
      reference: 0,
      replicableReferences: [],
      desactive: true
    }
  },
  watch: {
    uor () {
      if (this.uor) this.loadReplicableReferences()
    },
    employeesSelected (value) {
      this.update()
    },
    disabled (value) {
      this.desactive = value
    }
  },
  methods: {
    loadReplicableReferences () {
      this.showMessage('Carregando...')

      request.get(`escala/listar-referencias-replicaveis?uor_sigla=${this.uor}`,
      response => this.setReplicableReferences(response),
      error => console.log(error))
    },
    showMessage (message) {
      this.replicableReferences = [{ label: message, value: 0 }]
      this.setReference(0)
    },
    setReplicableReferences (data) {
      if (data && Array.isArray(data)) {
        this.replicableReferences = data.map(item => (this.createReferenceOption(item)))
      }

      const [selectedItem] = this.replicableReferences
      if (selectedItem) this.setReference(selectedItem.value)
      else this.showMessage('Não há escalas anteriores')
    },
    setReference (value) {
      this.$nextTick(() => {
        this.toggleDesactive(value === 0)
        this.reference = value 
      })
    },
    toggleDesactive(value) {
      if (this.disabled) {
        this.desactive = true
      } else {
        this.desactive = value
      }
    },
    createReferenceOption (reference) {
      const value = parseInt(reference)
      const year = reference.substr(0,4)
      const month = parseInt(reference.substr(-2)) - 1
      const date = new Date(year, month, 1)
      const label = capitalize(date.toLocaleString('pt-br', { month: 'long', year: 'numeric' }))

      return { value, label }
    },
    loadEmployees() {
      const { uor, reference, setEmployees, emitStatusLoading } = this
      if (reference === 0) return

      emitStatusLoading(true)
      this.employeesSelected = []
      
      request.get(`escala/replicar-funcionarios?uor_sigla=${uor}&referencia=${reference}`,
      response => setEmployees(response),
      error => {
        emitStatusLoading(false)
        this.$toastr.e('Houve uma falha ao tentar replicar os funcionários, Tente novamente daqui alguns minutos!')
        console.log(error)
      })
    },
    emitStatusLoading (value) {
      this.$emit('changeStatusLoading', value)
    },
    setEmployees (data) {
      if (data && Array.isArray(data)) {
          this.employeesSelected = data
      }

      this.emitStatusLoading(false)
    },
    update() {
      this.$emit('input', [...this.employeesSelected])
    }
  }
}
</script>

<style scoped>
section {
  display: inline-block;
  position: relative;
  width: 100%;
  margin-bottom: 10px;
}

section .control-wrapper {
  display: flex;
  justify-content: space-between;
}

label {
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
  font-family: BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
}

select {
  text-transform: uppercase;
}
</style>


// WEBPACK FOOTER //
// src/components/Employee/Replicate.vue